import useDelayBalanceUpdate from '@/hooks/biz/casino/useDelayBalanceUpdate';
import useLoginModal from '@/hooks/biz/useLoginModal';
import useTheme from '@/theme/useTheme';
import { MoonWinResult } from '@crownbit/icons';
import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import GameSettings from '../game-settings';
import RewardsDisplay from './RewardsDisplay';
import DrawCarousel from './carousel';
import { MOON_DRAW_UPDATE_BALACE_DELAY_MS } from './config';
import MoonDrawHistoryModal from './history-modal';
import MoonDrawIntro from './intro';
import GameRecommended from '../../common/GameRecommended';

const MoonDraw = () => {
  const [t] = useTranslation();
  const DRAW_REWARDS = [
    {
      amount: 999,
      chance: 0.00002,
      chancePercentage: 0.002,
      name: t('moon-draw::Prize I'),
    },
    {
      amount: 499,
      chance: 0.000035,
      chancePercentage: 0.0035,
      name: t('moon-draw::Prize II'),
    },
    {
      amount: 199,
      chance: 0.000045,
      chancePercentage: 0.0045,
      name: t('moon-draw::Prize III'),
    },
    {
      amount: 99,
      chance: 0.000065,
      chancePercentage: 0.0065,
      name: t('moon-draw::Prize IV'),
    },
    {
      amount: 60,
      chance: 0.00009,
      chancePercentage: 0.009,
      name: t('moon-draw::Prize V'),
    },
    {
      amount: 2.07,
      chance: 0.095,
      chancePercentage: 9.5,
      name: t('moon-draw::Prize VI'),
    },
    {
      amount: 1.8,
      chance: 0.09,
      chancePercentage: 9,
      name: t('moon-draw::Prize VII'),
    },
    {
      amount: 0.26,
      chance: 0.115175,
      chancePercentage: 11.5175,
      name: t('moon-draw::Prize VIII'),
    },
    {
      amount: 0.11,
      chance: 0.199915,
      chancePercentage: 19.9915,
      name: t('moon-draw::Prize IX'),
    },
    {
      amount: 0.02,
      chance: 0.199675,
      chancePercentage: 19.9675,
      name: t('moon-draw::Prize X'),
    },
    {
      amount: 0.01,
      chance: 0.29998,
      chancePercentage: 29.998,
      name: t('moon-draw::Prize XI'),
    },
  ];

  useDelayBalanceUpdate(MOON_DRAW_UPDATE_BALACE_DELAY_MS);

  const [historyModal, setHistoryModal] = useState(false);

  const [isLogin, showLoginModal] = useLoginModal();
  const { theme } = useTheme();

  return (
    <Stack gap={1}>
      <Stack
        display={'flex'}
        direction={'row'}
        gap={1}
        justifyContent={'flex-end'}
        my={3}
        alignSelf={'flex-end'}
        sx={{
          cursor: 'pointer',
        }}
        onClick={() => {
          if (isLogin) {
            setHistoryModal(true);
          } else {
            showLoginModal();
          }
        }}
      >
        <Typography color={'primary.main'} alignSelf={'center'}>
          {t('History')}
        </Typography>
        <Box
          sx={{
            border: theme.palette.border.normal,
            borderRadius: theme.spacing(1),
          }}
        >
          <MoonWinResult fontSize={'2em'} />
        </Box>
      </Stack>
      <MoonDrawHistoryModal
        open={historyModal}
        onClose={() => {
          setHistoryModal(false);
        }}
      />
      {/* <MoonDrawBanner /> */}
      <DrawCarousel drawRewards={DRAW_REWARDS}></DrawCarousel>
      <RewardsDisplay drawRewards={DRAW_REWARDS}></RewardsDisplay>
      <Box my={2}>
        <GameSettings gameId="draw" fairnessLink="/casino/fairness" />
      </Box>
      <MoonDrawIntro />
      <GameRecommended />
    </Stack>
  );
};

export default MoonDraw;
